// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"19c73583","357":"1cfa2cc8","507":"ecd455de","711":"c163bde0","763":"9ec16995","824":"a7a8a09f","988":"a7a8a09f"}[chunkId] + ".chunk.css";
};